export const timeDay = (date = new Date()) => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin' }).format(date);

// Runtime timestamps are ISO instants, unlike entry start_time/end_time (local SQL times).
// This is the recorded start time, deliberately not an invented elapsed-work timer.
export function startTimeLabel(value?: string) {
  const date = value ? new Date(value) : null;
  return date && Number.isFinite(date.getTime())
    ? new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' }).format(date)
    : '–';
}

export const entryTimeLabel = (value?: string | null) => value ? value.slice(0, 5) : '–';

export function approvalLabel(status: string) {
  return ({ open: 'Noch nicht eingereicht', draft: 'Entwurf', submitted: 'In Prüfung', approved: 'Freigegeben', rejected: 'Abgelehnt' } as Record<string, string>)[status] || status;
}
